export const orgBuilderRouteNames = {
   BUSINESS_UNIT_SUMMARY: 'business-unit-summary',
   DEPARTMENT_SUMMARY: 'department-summary',
   ORG_SUMMARY: 'summary',
   ORG_CHART: 'chart',
};
